/**
 * @deprecated Import Card parts from `~/design_system`. These re-exports exist
 * so leftover `~/components/v2/Card` callers still work. Delete this module
 * once those imports are repointed.
 *
 * @module Card
 */
export {
  Card,
  CardHeader,
  CardHeading,
  CardActionButton,
  CardActionLink,
  CardActionIcon,
  CardFooter,
  CardBody
} from '~/design_system'
